import { observer } from "mobx-react";

import { Hint } from "components/UI/Hint/Hint";
import Toggler from "components/UI/Toggler/Toggler";
import { DropDownList } from "./DropDownList/DropDownList";

import popupStore from "components/Popup/PopupStore";

import {
  REVIEW_PLACEHOLDER_TXT,
  REVIEW_ERROR_MESSAGE,
  HINT_REVIEW_NOTIFICATION,
} from "../activityRowConstants";

import "./ReviewComment.scss";

const ReviewComment = observer(
  ({
    store,
    reviewRef,
    generatedReviewRef,
    textareaReviewRef,
    showNotification,
    setShowNotification,
    adjustTextareaHeight,
    isMobile,
  }) => {
    const isCustomService = store.selectedOnlineService?.title === "Другое (укажите свою услугу)" || store.selectedOnlineService?.title === "Своя услуга";

    const toggleWarranty = () => {
      if (!store.reviewWarranty) {
        popupStore.open("warranty-popup");
      } else {
        store.setReviewWarranty(!store.reviewWarranty);
      }
    };

    return (
      <div className="review-comment">
        <div className="review-comment__container" ref={reviewRef}>
          <p className="review-comment__container-title">Техническое задание для тестировщика</p>

          {!store.market.hasNoServicesInReview && <div className="review-comment__box">
            <p className="review-comment__box-title">Какую услугу должен оценить тестировщик?</p>
            <DropDownList store={store} error={!store.selectedOnlineService && store.customOnlineServiceError}  textareaReviewRef={textareaReviewRef} />
            {isCustomService &&
              <>
                <span className="review-comment__box-span">или укажите свою</span>
                <div className="review-comment__box-field">
                  <textarea
                    className={`review-comment__box-field-textarea small ${store.customOnlineServiceError ? "error" : ""}`}
                    minLength={0}
                    maxLength={150}
                    placeholder="Например: «Онлайн-консультация стилиста», «Подбор ухода за кожей», «Расчет сметы на ремонт» и т.п."
                    value={store.customOnlineService}
                    onChange={(e) => {
                      store.setCustomOnlineService(e.target.value);
                      adjustTextareaHeight();
                    }}
                    ref={(el) => {
                      textareaReviewRef.current = el;
                      generatedReviewRef.current = el;
                    }}
                  />
                  <div className="review-comment__box-field-info">
                    {!isMobile && <p className="review-comment__box-field-info-description other-param">Услуга должна быть бесплатной и доступной онлайн</p>}
                    <span className="review-comment__box-field-info-count">{store.customOnlineService.length}/150</span>
                  </div>
                </div>
              </>
            }
            {(!isCustomService || isMobile) && <p className="review-comment__box-field-info-description other-param">Услуга должна быть {isMobile && <br />} бесплатной и доступной онлайн</p>}
          </div>}

          <div className="review-comment__box">
            {showNotification && <Hint className="hint-review-notification" title="Важное уведомление" text={HINT_REVIEW_NOTIFICATION} buttonText="Понятно" onClick={() => setShowNotification(false)} />}
            <p className="review-comment__box-title">О чем тестировщик должен написать в отзыве?</p>
            <div className="review-comment__box-field">
              <textarea
                className={`review-comment__box-field-textarea ${store.reviewCommentError ? "error" : ""}`}
                minLength={0}
                maxLength={550}
                placeholder={REVIEW_PLACEHOLDER_TXT}
                value={store.reviewComment}
                onChange={(e) => {
                  store.setReviewComment(e.target.value);
                  adjustTextareaHeight();
                }}
                ref={(el) => {
                  textareaReviewRef.current = el;
                  generatedReviewRef.current = el;
                }}
              />
              {store.reviewCommentError && <p className="review-comment__box-field-textarea-error-message">{REVIEW_ERROR_MESSAGE}</p>}
              <div className="review-comment__box-field-info">
                {!isMobile && <p className="review-comment__box-field-info-description">Не указывайте качества, <br /> которые нельзя протестировать удаленно</p>}
                <span className="review-comment__box-field-info-count">{store.reviewComment.length}/550</span>
              </div>
            </div>
            {isMobile && <p className="review-comment__box-field-info-description">Не указывайте качества, <br /> которые нельзя протестировать <br /> удаленно</p>}
          </div>

          <div className="review-comment__additions">

            <div className="review-comment__toggler">
              <div className="review-comment__toggler-left">
                <div className="review-comment__toggler-left-warranty-icon" />
                <p className="review-comment__toggler-left-title">Гарантия на отзывы</p>
              </div>
              <div className="review-comment__toggler-right">
                <p className="review-comment__toggler-right-text">(+{store.currentCalculator.reviewWarrantyPrice} ₽/<span>отзыв</span>)</p>
                <Toggler isActive={store.reviewWarranty} handler={toggleWarranty} />
              </div>
            </div>

            <div className="review-comment__toggler">
              <div className="review-comment__toggler-left">
                <div className="review-comment__toggler-left-photo-icon" />
                <p className="review-comment__toggler-left-title">Добавить фото в отзыв</p>
              </div>
              <Toggler isActive={store.isPhotosUpload} handler={() => store.setPhotosUpload(!store.isPhotosUpload)} />
            </div>

            {store.isPhotosUpload && (
              <input
                type="text"
                className="textinput"
                placeholder="Введите ссылку на файлообменник (например, Яндекс Диск)"
                value={store.photosUrl}
                onChange={(e) => store.setPhotosUrl(e.target.value)}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
);

export default ReviewComment;
